export const CURRENCY = 'USD';
export const TEALIUM_LANGUAGE = 'en_US';
export const CUSTOMER_HOME_PAGE_NAME = 'Customer Home';
export const CUSTOMER_SEARCH_PAGE_NAME = 'Customer Search';
export const CUSTOMER_DETAILS_PAGE_NAME = 'Customer Details';
export const ORDER_HOME_PAGE_NAME = 'Order Home';

export const ORDER_DETAILS_PAGE_NAME = 'Order Details';
export const PRODUCT_CATALOG_PAGE_NAME = 'Product Catalog';
export const PDP_PAGE_NAME = 'PDP';
export const CUSTOMER_SEARCH_PAGE_TYPE = 'Search For Customer';
export const CUSTOMER_INFO_PAGE_TYPE = 'Customer Information';
export const ORDER_INFO_PAGE_TYPE = 'Order Information';
export const REQUEST_HEADER_X_BY_PASS_CUSTOM_WAF = 'x-bypass-custom-waf';

export const ORDER_SEARCH_PAGE_TYPE = 'Search For Order';
export const SEARCH_PAGE_TYPE = 'Search';
export const RESULT_PAGE_TYPE = 'Results';
export const PRODUCT_PAGE_TYPE = 'Product';
export const CHECKOUT_PAGE_TYPE = 'Checkout';
export const CATEGORY_PAGE_TYPE = 'Category';
export const SITE = 'Site';

export const TEALIUM_EVENT_PURCHASE = 'purchase';
export const MAIN_IMAGE_URL = 'mainImageURL';
export const DEPARTMENT = 'department';
export const ABWSTYLE = 'abwStyle';
export const BRAND_NAME = 'brandName';
export const CUSTOMER_ZIP_CODE_SEARCH = 'Zip Code/Last Name/First Name';

export const TEALIUM_EVENT_TYPE_VIEW = 'view';
export const TEALIUM_PAGE_NAME_USER_MAIN = 'userMain';
export const TEALIUM_GENDER_UNKNOWN = 'unknown';
export const TEALIUM_PAGE_NAME_HOME = 'Home';
export const TEALIUM_PAGE_NAME_GENERIC = 'generic';
export const CLASS = 'class';
export const SUB_CLASS = 'subClass';
export const TEALIUM_PAGE_NAME_PDP = 'PDP';
export const TEALIUM_PAGE_BASKET = 'Basket';
export const TEALIUM_PAGE_SHIPPING_PAYMENT_REVIEW = 'ShippingPaymentReview';
export const TEALIUM_PAGE_BASKET_DRAWER = 'Basket Drawer';
export const TEALIUM_PAGE_TYPE_PRODUCT = 'Product';
export const PRODUCT_VIEW = 'product_view';
export const CART_ADD_EVENT = 'cart_add';
export const SAVE_FOR_LATER_EVENT = 'save_for_later';
export const PRODUCT_CLICK_EVENT = 'product_click';
export const EMAIL_ADD_EVENT = 'email_add';
export const REMOVE_ITEM_EVENT = 'cart_remove';
export const ADD_TO_WISH_LIST_EVENT = 'add_to_wishlist';
export const TEALIUM_PAGE_TYPE_CHECKOUT = 'checkout';
export const TEALIUM_EVENT_TYPE_CHECKOUT = 'checkout';
export const TEALIUM_PAGE_NAME_SHIPPING = 'Shipping';
export const TEALIUM_PAGE_NAME_PAYMENT = 'Payment';
export const TEALIUM_PAGE_NAME_REVIEW = 'Review';
export const TEALIUM_SIGNED_IN = 'signed in';
export const TEALIUM_PAYMENT_METHOD_CREDIT = 'CREDIT';
export const TEALIUM_PAYMENT_METHOD_CARD = 'CARD';
export const TEALIUM_PAYMENT_METHOD_PAYPAL = 'PAYPAL';
export const TEALIUM_PAYMENT_METHOD_CASH = 'CASH';
export const TEALIUM_PAYMENT_METHOD_CHECK = 'CHECK';
export const TEALIUM_PAYMENT_METHOD_NOCHARGE = 'noCharge';

export const TEALIUM_SIGNED_OUT = 'signed out';
export const TEALIUM_PAYMENT_TYPE_CREDIT = 'mason_credit';
export const TEALIUM_PAYMENT_TYPE_CARD = 'credit_card';
export const TEALIUM_PAYMENT_TYPE_CASH = 'cash';
export const TEALIUM_PAYMENT_TYPE_CHECK = 'check';
export const TEALIUM_PAYMENT_TYPE_NOCHARGE = 'nocharge';
export const TEALIUM_PAYMENT_TYPE_PAYPAL = 'paypal';

export const PAYMENT_TYPE_PAYPAL = 'paypal';
export const TEALIUM_DEFAULT_CATEGORY = 'c342405';
export const TEALIUM_ITEM_LEVEL = 'item';
export const TEALIUM_ORDER_LEVEL = 'order';
export const TEALIUM_PAGE_TYPE_LANDING = 'Landing';
export const TEALIUM_PAGE_NAME_CONFIRMATION = 'Confirmation';
export const TEALIUM_PAGE_NAME_ONLINE_CATALOG = 'Online Credit Catalog';
export const TEALIUM_PAGE_NAME_RESULTS = 'Results';
export const TEALIUM_PAGE_NAME_NO_RESULTS = 'No Search Results';
export const TEALIUM_PAGE_NAME_BRAND = 'brand';
export const TEALIUM_PAGE_TYPE_SEARCH = 'Search';
export const TEALIUM_PAGE_NAME_PLP = 'PLP';
export const TEALIUM_PAGE_NAME_CLP = 'CLP';
export const TEALIUM_PAGE_TYPE_CATEGORY = 'Category';
export const TEALIUM_PAGE_TYPE_SECTION = 'Section';
export const TEALIUM_PAGE_TYPE_BRAND_LISTING = 'BrandListing';
export const TEALIUM_SEARCH_RESULT = 'Search Results';
export const TEALIUM_BRAND_LISTING = 'Brand Listing';
export const TEALIUM_PRODUCT_LISTING = 'Product Listing page';
export const TEALIUM_PRODUCT_EN_US = 'en-US';
export const TEALIUM_FILTER = 'Filter';
export const TEALIUM_PAGE_NAME_BUYNOW_PAYLATER = 'Buy Now Pay Later';

export const CUSTOMER_TYPE_DPQ_ELIGIBLE = 'DPQEligible';
export const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD'; // 2024-05-27
export const CUSTOMER_TYPE_DPQ_IN_ELIGIBLE = 'DPQInEligible';
export const ISO_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss'; //2024-05-27T19:42:32
export const CUSTOMER_TYPE_DPQ = 'DPQCustomer';
export const CUSTOMER_TYPE_LONG_STANDING = 'LongStandingCustomer';
export const PREQUAL_STATUS_APPROVED = 'approved';
export const DIFFERNCE_IN_DAYS = 'days';
export const INVALID_SSN_VALUE = '0000';
export const DATE_FORMAT_MMDDYYYY = 'MM/DD/YYYY'; // 05/27/2024
export const SUCCESS_CODE_OK = 'OK';
export const AVAILABILITY_VALUE_OUT_OF_STOCK = 'outOfStock';
export const AVAILABILITY_VALUE_EXCEEDED = 'quantityExceeded';
export const RECENTLY_REMOVED = '__recentlyRemoved';
export const ZIP_CODE_COOKIE_MAX_AGE = 1;
export const COOKIE_NAME_ZIP_CODE = 'zipCode';
export const VERIFIED_MATCH = 'verified match';
export const ORDER_ACCEPTABLE = 'OrderAcceptable';
export const CARD_SAVABLE = 'Savable';
export const PAYMENT_ACCEPTABLE = 'PaymentAcceptable';

export const UTM_SOURCE = 'utm_source';
export const UTM_MEDIUM = 'utm_medium';
export const UTM_CAMPAIGN = 'utm_campaign';
export const COOKIE_NAME_UTM_SOURCE = 'prequalutmsource';
export const COOKIE_NAME_UTM_MEDIUM = 'prequalutmmedium';
export const COOKIE_NAME_UTM_CAMPAIGN = 'prequalutmname';
export const UTM_COOKIE_MAX_AGE = 1209600;
export const COOKIE_NAME_LOCALE = 'locale';
export const COOKIE_LOCALE_VALUE = 'en';
export const LOCALE_COOKIE_MAX_AGE = 2419200;
export const cardRegex = {
  visa: /^4\d{12}(?:\d{3})?$/,
  mastercard: /^5[1-5]\d{14}|^(222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[0-1]\d|2720)\d{12}$/,
  discover: /^6(?:011|5\d{2})\d{12}$/,
  amex: /^3[47]\d{13}$/,
};

export const DEFAULT_SITE_LANG = 'en';
export const UNSUPPORTED_PAGES = ['/'];
export const CSA_HOME_URL = '/customer-search';
export const PAYMENT_FAILURES_QUEUE_VALUE = 'PaymentFailures';
export const INTERNET_HOLDS_QUEUE_VALUE = 'InternetHolds';
export const EDIT_PHONE_NUMBER = 'edit-phone-number';
export const EDIT_EMAIL = 'edit-email';
export const MASTER_LEVEL = 'master-level';
export const DIVISION_LEVEL = 'division-level';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const MONTH_YEAR_FORMAT = 'MM/YY';
export const TIME_FORMAT = 'hh:mm:ss A';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm:ss A';
export const DATE_MONTH_FORMAT = 'MMMM D, YYYY';
export const CUSTOMER_DETAILS_CONSTANTS = {
  ORDER_ID: 'Order ID',
  CUSTOMER: 'Customer',
  DIVISION: 'Division',
  ORIGIN: 'Origin',
  STATUS: 'Status',
  SUBMITTED: 'Submitted',
  AGENT: 'Agent',
  CONFIRMATION_THIRD_PARTY_ORDER_ID: 'Confirmation/Third Party Order ID',
};
export const SEARCH_CUSTOMER_PAGE_PATH = 'customer-search';
export const SEARCH_ORDER_PAGE_PATH = 'order-search';
export const CREATE_CUSTOMER_PAGE_PATH = 'create-customer';
export const CUSTOMER_DETAILS_PAGE_PATH = 'customer-details';
export const ORDER_DETAILS_PAGE_PATH = 'order-details';
export const FORM_FIELD_SPECS = {
  phoneNumber: { id: 'phoneNumber' },
  phone: { id: 'phone' },
  emailAddress: { id: 'emailAddress', maxLength: 100 },
  zip: { id: 'zip', maxLength: 10 },
  zipCode: { id: 'zip', maxLength: 10 },
  lastName: { id: 'lastName', maxLength: 28 },
  firstName: { id: 'firstName', maxLength: 28 },
  companyName: { id: 'companyName', maxLength: 40 },
  addressLine1: { id: 'streetName', maxLength: 30, label: 'Street Name' },
  postalCode: { id: 'postalCode', maxLength: 10, label: 'Postal Code' },
  line1: { id: 'line1', maxLength: 30 },
  line2: { id: 'line2', maxLength: 30 },
  addressLine2: { id: 'addressLine2', maxLength: 30 },
  city: { id: 'city', maxLength: 30, label: 'City' },
  state: { id: 'state' },
  dateOfBirth: { id: 'dob' },
  ssn: { id: 'ssn', maxLength: 4 },
  orderId: { id: 'orderId', maxLength: 9 },
  additionalAddressInfo: { id: 'additionalAddressInfo', maxLength: 30, label: 'Address Line 2' },
  confirmationId: { id: 'confirmationId', maxLength: 19 },
  catalogId: { id: 'mailingRecordId', maxLength: 10 },
  otherIdentifierId: { id: 'customerId', maxLength: 19 },
  email: { id: 'email', htmlFor: 'email', label: "'EmailAddress'" },
  country: { id: 'country', default: 'US', type: 'hidden' },
  mailReturnUndeliverable: { id: 'mailReturnUndeliverable' },
  queueName: {
    id: 'queueName',
    options: [
      { label: 'Amazon Order Holds', value: 'AmazonHolds' },
      { label: 'OMS Agent Holds', value: 'OMSAgentHolds' },
      { label: 'eBay Holds', value: 'eBayHolds' },
      { label: 'Internet Holds', value: 'InternetHolds' },
      { label: 'Invoice Holds', value: 'InvoiceHolds' },
    ],
  },
  zipCodeSearch: { id: 'zip', maxLength: 5 },
};
export const COOKIE_KEYS = {
  selectedSite: 'selectedSite',
  CDP_URL: 'current_CDP_URL',
  LOCALE: 'locale',
  URL_HISTORY: 'urlHistory',
  agentRole: 'agentRole',
  caseNumber: 'caseNumber',
  caseId: 'caseId',
  AGENT_EMAIL: 'agentEmail',
  CURRENT_ENVIRONMENT: 'currentEnvironment',
};
export const PAGE_TEXTS_KEYS = {
  customerAndOrderSearch: 'customer-and-order-search',
};
export const SITE_KEY_MAP: { [key: string]: string | undefined } = {
  ZB: 'Stoneberry',
  ZY: 'Masseys',
  MQ: 'Maryland Square',
  SM: 'ShoeMall',
  ZD: 'Mason Easy Pay',
  ZA: 'K. Jordan',
  ZF: 'Birchland Market',
  ZC: 'Fifth & Glam',
  FG: "Figi's GIGT",
  FB: "Figi's Gallery",
};

export const SITE_KEY_MAP_MO: { [key: string]: string | undefined } = {
  ZB: 'Stoneberry',
  ZY: 'Masseys',
  MQ: 'Maryland Square',
  SM: 'ShoeMall',
  ZD: 'Mason Outfitters',
  ZA: 'K. Jordan',
  ZF: 'Birchland Market',
  ZC: 'Fifth & Glam',
  FG: "Figi's GIGT",
  FB: "Figi's Gallery",
};

export const SITE_KEY_MAP_OC: { [key: string]: string | undefined } = {
  ZB: 'Stoneberry',
  ZY: 'Masseys',
  MQ: 'Maryland Square',
  SM: 'ShoeMall',
  ZD: 'Mason Easy-Pay',
  ZA: 'K. Jordan',
  ZF: 'Birchland Market',
  ZC: 'Fifth & Glam',
  FG: "Figi's GIGT",
  FB: "Figi's Gallery",
};

export const phoneFormatRegex = /^\(\d{3}\)\d{3}-\d{4}$/;
export const emailFormatRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const zipFormatRegex = /^\d{5}(-\d{4})?$/;
export const customerNameRegex = /^[a-zA-Z0-9\s-]*$/;
export const addressRegex = /[^a-zA-Z0-9\s/#.,;:'\-\/\u00B0]+/g;
export const cityRegex = /^[a-zA-Z\s\-,.;'&/()]+$/;
export const MONETARY_INPUT_REGEX = /^\d*(\.\d{0,4})?$/;
export const ALPHANUMERIC_REGEX = /^[a-z0-9 ]+$/i;
export const POSITIVE_INTEGER_REGEX = /^\d+$/;
export const ADDITIONAL_DETAILS_TYPE = {
  REASONS: 'reasons',
  NOTES: 'notes',
};
export const ADDITIONAL_DETAILS_NAME = {
  ADJUST_PRICE: 'Adjust-Price',
  HOLD_ORDER: 'Hold-Order',
  ADD_NOTE: 'Add-Note',
};
export const numericRegex = /^\d{0,10}(\.\d{0,2})?$/;
export const defaultDurationInMonths = 24;
export const DISABLE_PAGES = ['cart', 'search', 'product'];
export const DISABLE_ACCOUNT_NUMBER = ['create-customer', 'customer-search', 'order-search'];
export const BREADCRUMB = ['search', 'cart', 'product', 'order-details', 'checkout'];
export const MAX_PAGE_SIZE = 100;
export const ORDER_STATUS_CANCELLED = 'Cancelled';
export const IsShippingInclude = [
  'Remove Standard Shipping Charges',
  'Remove Expedited Shipping Charges',
  'Remove All Shipping Charges',
];
export const CONSTANTS_RESPONSE = {
  SUCCESS_CODE_OK: 'OK',
  VERIFIED_MATCH: 'verified match',
};
export const VARIANT_SELECTOR_VALUE_1 = 'variantSelectorValue1';
export const VARIANT_SELECTOR_VALUE_3 = 'variantSelectorValue3';
export const VARIANT_SELECTOR_VALUE_2 = 'variantSelectorValue2';
export const BRAND_TEXT_TO_REPLACE = '$BRAND$';
export const ALOGLIA_SUCCESS_STATUS = 'idle';
export const ALOGLIA_SUCCESS_LOADING = 'loading';
export const SEARCH_BY_ORDER_QUEUES = 'SEARCH_BY_ORDER_QUEUES';
export const CREDIT_NOTES = 'CREDIT_NOTES';
export const NO_CHARGE_ORDER = 'NO_CHARGE_ORDER';
export const RELEASE_ORDER = 'RELEASE_ORDER';
export const NOTES_FLAG_FOR_PAPERWORK = 'NOTES_FLAG_FOR_PAPERWORK';
export const ALL_PAYMENT_MEDIUM = 'Phone';
export const RESPONSE_BAD_REQUEST = 'BAD-REQUEST';
export const FAILED = 'FAILED';
export enum ORDER_TYPES {
  NO_CHARGE = 'noCharge',
  MAIL_ORDER = 'mailOrder',
  NEW_ORDER = 'newOrder',
}
export const IS_PERSONALIZED = 'isPersonalized';
export enum ADJUSTMENT_TYPES {
  DOLLAR_OFF = 'dollarOff',
  PERCENTAGE_OFF = 'percentageOff',
  REMOVE_STANDARD_SHIPPING = 'removeStandard',
  REMOVE_EXPEDITED_SHIPPING = 'removeExpedited',
  REMOVE_ALL_SHIPPING = 'removeAll',
}
export const AVAILABILITY_VALUE_BACKORDERED = 'backOrdered';

export const ADJUST_ITEM_MODAL_CONSTANTS = {
  ADJUSTMENTS: [
    {
      value: 'Dollar Off',
    },
    {
      value: 'Percent Off',
    },
    {
      value: 'Item Price',
    },
  ],
  REASONS: [
    {
      value: 'Customer Service Issue',
    },
    {
      value: 'Price Correction',
    },
    {
      value: 'Problems With PZ',
    },
    {
      value: 'Customer To Return Later',
    },
    {
      value: 'Lost Parcel Replacement',
    },
  ],
};

export const SEND_TRACER_TYPE = {
  REQUEST_TYPE: 'Tracer',
  SEND_VIA_TYPE: 'mail',
};
export const LINE_ITEMS_TABLE_KEYS = {
  ITEM_DESCRIPTION: 'itemDescription',
  CHECKBOX: 'checkbox',
  QUANTITY: 'quantity',
};
export const CANCEL_TYPE = {
  ORDER: 'Order',
  ITEM: 'Item',
};
export const ADJUSTMENTS = {
  DOLLAR_OFF: 'dollarOff',
  PERCENT_OFF: 'percentageOff',
};
export const DEFAULT_AGENT_NAME = 'agentCSA';
export const DEFAULT_INITIATING_AGENT = 'CSA';
export const DEFAULT_INITIATING_SYSTEM = 'CSA';
export const CURRENT_SECTION = {
  PAY_RECORD: 'payRecord',
  INVOICE: 'invoice',
  ADJUSTED_ITEMS: 'adjustedItem',
};
export const INVOICE_TABLE_HEADER: any = {
  INVOICE_NUMBER: 'Invoice #',
  DATE: 'Date',
  NUMBER_OF_ITEMS: '# of items',
  PRICE: 'Price',
  TAX: 'Tax',
  SHIPPING: 'Shipping',
  TOTAL_AMOUNT: 'Total Amount',
};
export const INVOICE_TABLE_KEYS = {
  INVOICE_NUMBER: 'invoiceNumber',
  DATE: 'date',
  NUMBER_OF_ITEMS: 'numberOfItems',
  PRICE: 'price',
  TAX: 'tax',
  SHIPPING: 'shipping',
  TOTAL_AMOUNT: 'totalAmount',
  TRACK_ID: 'trackId',
};
export const PRODUCT_STATUS_CODE = {
  SHIPPED: 'SHP',
  ADJUSMENT: 'ADJ',
  RETURN: 'RET',
  PROCESSING: 'PRO',
  CANCELLED: 'CAN',
  BACKORDER: 'BAK',
};
export const GROUP_ORDER_TITLE = {
  SHIPPED: 'Shipped',
  AWAITING_SHIPMENT: 'Awaiting Shipment',
};
export const EDIT_ADDRESS_OPTIONS = {
  SAVED_ADDRESS: { id: 'savedAddress', value: 'SAVE_ADDRESS' },
  NEW_ADDRESS: { id: 'newAddress', value: 'NEW_ADDRESS' },
};
export const RETURN_LABEL_SENT = 'Return Label sent';
export const STATUS_REFUND = 'REFUND';
export const STATUS_FRIEGHT = 'FREIGHT';
export const ORDER_CONFIRMATION_NUMBER = 'orderConfirmationId';
export const FULFILLMENT_METHOD = 'fulfillmentMethod';
